import { styled } from "styled-components";

const Container = styled.div`
  body { margin: 20px; }
  h1, h2, h3 { margin: 2rem 0; }
  h1 { font-size: 24px; }
  h2 { font-size: 20px; }
  h3 { font-size: 18px; }
  p, li { margin: 5px 0; }
  ul { margin: 10px 0 10px 20px; }
  .indent { margin-left: 20px; }
`;

export function PrivacyPolicy() {
  return (
    <Container>
      <h2>제1조(개인정보의 수집 및 이용 목적, 항목, 보유기간, 수집방법)</h2>
      <p>FOCUS AI는 아래와 같은 목적으로 개인정보를 수집 및 이용하며, 이용 목적이 달성된 후에는 지체 없이 파기합니다.</p>
      <h3>1. 수집 대상 및 유형</h3>
      <ul>
          <li>하드웨어 사용 고객: CCTV, DVR, NVR 등 제품 사용자</li>
          <li>모바일 애플리케이션 이용자: FOCUS AI 앱 이용자</li>
          <li>AI 서비스 사용자: AI 기반 영상분석 및 보안 서비스 이용자</li>
      </ul>
      <h3>2. 수집하는 개인정보 항목</h3>
      <ul>
          <li>인적정보: 성명, 생년월일, 성별, 주소, 휴대전화번호(통신사 포함), 유선전화번호, 이메일 등</li>
          <li>가입정보: 가입일, 유형, 가입·요금상품, 결합정보, 기간, 해지 등</li>
          <li>사업장 정보: 사업체명, 상호, 업태, 사업자번호 또는 외국인등록번호 등</li>
          <li>기록정보: 접속로그(IP포함), Cookie, 서비스이용기록 등</li>
          <li>서비스 이용 내용: 구매내역, 결제정보, 고객 요청 사항 및 상담 이력 등</li>
          <li>기타: 영상정보, 법정대리인 정보, 금융기관명, 계좌정보 등</li>
      </ul>
      <h3>3. 개인정보 수집 및 이용 목적</h3>
      <ul>
          <li>고객 식별 및 본인 여부 확인</li>
          <li>서비스 제공 및 유지보수</li>
          <li>은행/카드 자동이체 등록, 출금 연체정보 제공</li>
          <li>고객 문의 응대 및 민원 처리</li>
          <li>서비스 이용 통계 분석 및 개선</li>
          <li>AI 기반 보안 서비스 운영 등</li>
      </ul>
      <h3>4. 개인정보 보유 및 이용 기간</h3>
      <p>원칙적으로 개인정보의 이용 목적이 달성된 후에는 즉시 파기하며, 법령에 따라 보관이 필요한 경우 일정 기간 보존합니다.</p>
      <h2>제3조(개인정보의 제3자 제공)</h2>
      <p>① FOCUS AI는 원칙적으로 고객의 개인정보를 제1조에서 명시한 목적 범위 내에서 처리하며, 고객의 사전 동의 없이는 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다. 단, 다음의 각 호의 경우에는 고객 또는 제3자의 이익을 부당하게 침해할 우려가 있을 때를 제외하고는 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공할 수 있습니다.</p>
      <ul>
          <li>1. 고객이 사전에 제3자 제공 및 공개에 동의한 경우</li>
          <li>2. 다른 법률에 특별한 규정이 있는 경우</li>
          <li>3. 고객 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 고객 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
      </ul>
      <p>② FOCUS AI는 제1항 제1호에 따른 동의를 받을 때에는 다음 각 호의 사항을 고객에게 알립니다. 다음 각 호의 어느 하나의 사항을 변경하는 경우에도 이를 고객에게 알리고 동의를 받습니다.</p>
      <ul>
          <li>1. 개인정보를 제공받는 자</li>
          <li>2. 개인정보의 이용 목적(제공 시에는 제공받는 자의 이용 목적을 말한다)</li>
          <li>3. 이용 또는 제공하는 개인정보의 항목</li>
          <li>4. 개인정보의 보유 및 이용 기간(제공 시에는 제공받는 자의 보유 및 이용 기간을 말한다)</li>
          <li>5. 동의를 거부할 권리가 있다는 사실 및 동의 거부에 따른 불이익이 있는 경우에는 그 불이익의 내용</li>
      </ul>
      <h2>제4조(수집한 개인정보의 처리위탁)</h2>
      <p>① FOCUS AI는 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 향후 수탁자 및 위탁하는 업무의 내용이 변경될 경우 지체 없이 본 방침을 통해 고지하겠습니다.</p>
      <p>② FOCUS AI는 수탁업체와의 위탁계약 체결 시 관련 법령에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적ㆍ관리적ㆍ물리적 보호조치 등을 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
      <h2>제5조(개인정보의 분리보관 또는 파기)</h2>
      <p>① FOCUS AI는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 분쟁 해결 등을 위하여 개인정보의 보존이 필요한 경우에는 별도로 저장ㆍ관리할 수 있습니다.</p>
      <p>② 출력물, 서면 등은 파쇄 또는 소각의 방법으로, 전자적 파일형태의 개인정보는 복원이 불가능한 방법으로 파기합니다.</p>
      <p>③ 모바일 어플리케이션 삭제 후에도 실제 개인정보는 회사가 보유하며, 삭제를 원하는 경우 별도의 회원탈퇴 또는 동의 철회 과정이 필요합니다.</p>
      <p>④ 위치정보 이용ㆍ제공 사실 확인자료는 6개월간 보존합니다.</p>
      <h1>FOCUS AI 개인정보 처리방침</h1>
      <h2>제6조(고객의 권리와 그 행사방법)</h2>
      <p>① 고객은 FOCUS AI가 처리하는 정보들에 대하여 자신 및 14세 미만 아동(법정대리인만 해당)의 개인정보의 열람•제공을 아래 제9조에 명시된 연락처로 요구할 수 있습니다. 세부적인 정보는 아래와 같습니다:</p>
      <ul>
          <li>이 처리방침 제1조(수집하는 개인정보의 목적, 항목 및 수집방법, 보유 및 이용기간)에 명시한 정보</li>
          <li>제3조(개인정보의 제3자 제공)에 명시한 정보</li>
          <li>제4조(수집한 개인정보의 위탁)에 명시한 정보</li>
          <li>제8조(인터넷 접속정보파일 등 개인정보를 자동으로 수집하는 장치의 설치∙운영 및 그 거부에 관한 사항)에 명시한 정보</li>
          <li>고객이 개인정보 수집·이용·제공에 동의한 현황</li>
      </ul>
      <p>② 고객은 자신의 개인정보를 열람한 사실과 다르거나 확인할 수 없는 개인정보에 대하여 FOCUS AI에 정정 또는 삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 보존 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
      <p>③ 고객은 FOCUS AI에 대하여 자신의 개인정보 처리의 정지를 요구할 수 있습니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 FOCUS AI는 해당 사유를 고객에게 알리고, 처리정지 요구를 거절할 수 있습니다:</p>
      <ul>
          <li>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</li>
          <li>다른 사람의 생명•신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
          <li>개인정보를 처리하지 아니하면 고객과 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 고객이 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우</li>
      </ul>
      <p>④ FOCUS AI 앱(App.) 서비스를 이용하는 고객의 경우 앱 내 또는 고객센터를 통해 개인정보 삭제(탈퇴)를 요구할 권리를 행사할 수 있으며, 요청에 따라 파기 및 보관되는 데이터 항목은 제1조(개인정보의 수집, 이용목적, 항목 및 보유기간, 수집방법)에서 확인할 수 있습니다.</p>
      <h3>대상 서비스 방법</h3>
      <ul>
          <li>모바일 앱: 앱의 가이드에 따름</li>
          <li>고객센터 요청: (이메일, 콜)</li>
      </ul>
      <h2>제7조(아동의 개인정보보호 및 법정대리인의 권리)</h2>
      <ol>
          <li>FOCUS AI는 만14세 미만 아동(이하 ‘아동’)의 개인정보 수집/이용/제공 등을 하는 경우 해당 아동의 법정대리인의 동의를 얻도록 하고 있습니다.</li>
          <li>FOCUS AI는 아동의 서비스 이용 신청 시 법정대리인의 동의를 얻기 위하여 법정대리인의 성명, 연락처 등 필요한 최소한의 정보를 요구할 수 있습니다. 이 경우 개인정보의 수집•이용 또는 제공 목적 및 법정대리인의 동의가 필요하다는 취지를 아동이 쉽게 이해할 수 있는 평이한 표현으로 아동에게 고지합니다.</li>
          <li>FOCUS AI는 법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정 대리인의 동의여부를 확인하는 목적 외의 용도로 이를 이용하거나 제3자에게 제공하지 않습니다.</li>
          <li>아동의 법정대리인은 아동에 관해 FOCUS AI가 보유하고 있는 개인정보 수집•이용•제공 동의를 철회할 수 있고, FOCUS AI가 개인정보를 이용하거나 제3자에게 제공한 현황, 개인정보의 수집•이용•제공 등의 동의 현황을 열람하거나 제공받을 수 있으며, 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.</li>
          <li>FOCUS AI는 다음 각 호에 해당하는 자(이하 "8세 이하의 아동" 등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 수집, 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
              <ul>
                  <li>8세 이하의 아동</li>
                  <li>피성년후견인</li>
                  <li>"장애인복지법" 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 "장애인고용촉진 및 직업재활법" 제2조 제2호의 규정에 의한 중증장애인에 해당하는 자("장애인복지법" 제32조의 규정에 의하여 장애인등록을 한 자에 한한다.)</li>
              </ul>
          </li>
          <li>8세 이하의 아동 등의 보호의무자는 8세 이하의 아동 등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.
              <ul>
                  <li>8세 이하의 아동의 법정대리인 또는 『보호시설에 있는 미성년자의 후견직무에 관한 법률』 제3조의 규정에 의한 후견인</li>
                  <li>피성년후견인의 법정대리인</li>
                  <li>제1항 제3호의 자의 법정대리인 또는 "장애인복지법" 제58조 제1항 제1호의 규정에 의한 장애인생활시설(국가 또는 지방자치단체가 설치ㆍ운영하는 시설에 한한다)의 장, "정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률" 제22조에 의한 정신요양시설의 장 및 같은 법 제26조에 따른 정신재활시설(국가 또는 지방자치단체가 설치∙운영하는 시설로 한한다)의 장</li>
              </ul>
          </li>
          <li>"위치정보법" 제18조 내지 제22조, 제24조의 규정은 보호의무자가 동의를 하는 경우에 이를 준용하며, 이 경우 ‘개인위치정보주체’는 ‘보호의무자’로 봅니다.</li>
          <li>8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 수집∙이용 또는 제공에 동의하고자 하는 보호의무자는 서명동의서에 보호의무자임을 증명하는 서류를 첨부하여 회사에 제출하여야 하며, 보호의무자는 8세 이하의 아동 등의 개인위치정보 수집∙이용∙제공에 동의하는 경우 개인 위치정보주체 권리의 전부를 행사할 수 있습니다.</li>
      </ol>
      <h2>제8조(인터넷 접속정보파일 등 개인정보를 자동으로 수집하는 장치의 설치∙운영 및 그 거부에 관한 사항)</h2>
      <div>
          <p>① FOCUS AI는 고객에게 제공하는 서비스의 이용 및 접속 로그를 저장하고 이를 분석하여, 서비스 개선 및 마케팅 활용 등을 목적으로 사용합니다.</p>
          <p>② FOCUS AI는 고객의 인터넷접속정보 파일 또는 모바일 앱에서 발생한 접속정보 및 각종 행동에 대한 데이터를 수집할 수 있습니다. 고객은 이를 수시로 삭제하고, 장치에서 수집된 데이터의 처리 여부를 알 수 있습니다.</p>
      </div>
      <h2>제9조(개인정보 보호 책임자 및 연락처)</h2>
      <div>
          <p>FOCUS AI는 개인정보 보호에 대한 고객의 의견을 수렴하고 불만처리를 담당하는 개인정보 보호 책임자를 아래와 같이 지정하고 있습니다.</p>
          <ul>
              <li>개인정보 보호 책임자: 김상우</li>
              <li>담당 부서: 경영관리본부</li>
              <li>이메일: ksw113kr@focushns.com</li>
              <li>전화번호: 070-4610-4733</li>
          </ul>
      </div>
    </Container>
  )
}